import React, { useState } from 'react';

const FORMSPREE_ENDPOINT = 'https://formspree.io/f/YOUR_FORM_ID'; // TODO: replace with your real Formspree form ID once you create an account at formspree.io

export default function ModalEnquiry({ open, onClose, triggerLabel = 'Enquire Now' }) {
  const [show, setShow] = useState(open);
  const [form, setForm] = useState({ name: '', email: '', phone: '', resume: null });
  const [status, setStatus] = useState('idle');

  React.useEffect(() => { setShow(open); if (open) setStatus('idle'); }, [open]);

  const handleChange = e => {
    const { name, value, files } = e.target;
    setForm(f => ({ ...f, [name]: files ? files[0] : value }));
  };

  const reset = () => {
    setForm({ name: '', email: '', phone: '', resume: null });
    setStatus('idle');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('sending');
    try {
      const fd = new FormData();
      fd.append('name', form.name);
      fd.append('email', form.email);
      fd.append('phone', form.phone);
      if (form.resume) fd.append('resume', form.resume);

      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: fd,
      });

      if (res.ok) {
        setStatus('sent');
        setTimeout(() => {
          reset();
          setShow(false);
          if (onClose) onClose();
        }, 1500);
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  const handleClose = () => {
    setShow(false);
    reset();
    if (onClose) onClose();
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4" style={{ backgroundColor: 'rgba(10,10,10,0.7)' }}>
      <div className="card relative p-8 max-w-md w-full flex flex-col items-center fade-in-up">
        <button
          className="absolute top-4 right-4 text-2xl leading-none transition-colors"
          style={{ color: 'var(--text-muted)' }}
          onClick={handleClose}
          aria-label="Close"
        >
          ×
        </button>
        <h3 className="t-h2 mb-6" style={{ color: 'var(--text-primary)' }}>{triggerLabel}</h3>
        <form className="w-full flex flex-col gap-4" onSubmit={handleSubmit}>
          <label className="flex flex-col t-sm gap-1" style={{ color: 'var(--text-secondary)' }}>
            Name
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
              autoComplete="off"
              className="mt-1 px-4 h-11 rounded-ctl border t-body"
              style={{ backgroundColor: 'var(--bg-elevated)', borderColor: 'var(--border-medium)', color: 'var(--text-primary)' }}
            />
          </label>
          <label className="flex flex-col t-sm gap-1" style={{ color: 'var(--text-secondary)' }}>
            Email
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              autoComplete="off"
              className="mt-1 px-4 h-11 rounded-ctl border t-body"
              style={{ backgroundColor: 'var(--bg-elevated)', borderColor: 'var(--border-medium)', color: 'var(--text-primary)' }}
            />
          </label>
          <label className="flex flex-col t-sm gap-1" style={{ color: 'var(--text-secondary)' }}>
            Phone
            <input
              type="tel"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              autoComplete="off"
              className="mt-1 px-4 h-11 rounded-ctl border t-body"
              style={{ backgroundColor: 'var(--bg-elevated)', borderColor: 'var(--border-medium)', color: 'var(--text-primary)' }}
            />
          </label>
          <label className="flex flex-col t-sm gap-1" style={{ color: 'var(--text-secondary)' }}>
            Resume (optional)
            <input
              type="file"
              name="resume"
              accept=".pdf,.doc,.docx,.txt"
              onChange={handleChange}
              className="mt-1 t-sm"
              style={{ color: 'var(--text-secondary)' }}
            />
          </label>
          <button type="submit" className="btn btn-primary mt-2" disabled={status === 'sending'}>
            {status === 'sending' ? 'Sending…' : 'Send Enquiry'}
          </button>
          {status === 'sent' && (
            <p className="t-sm text-center" style={{ color: '#7fa98c' }}>Thanks — we'll be in touch shortly.</p>
          )}
          {status === 'error' && (
            <p className="t-sm text-center" style={{ color: '#d4674a' }}>
              Something went wrong. Please email us directly at contact@ufeus.com.
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
